import React from 'react';
import QRCodeLink from 'src/components/QRCodeLink';
import { Text } from '@consta/uikit/Text';
import { Button } from '@consta/uikit/Button';
import { IconClose } from '@consta/uikit/IconClose';

import cn from 'classnames/bind';
import styles from './styles.styl';

const cx = cn.bind(styles);

export interface IQRCodeLinkModalProps {
  closeModal: () => void;
  surveyName: string;
}

const QRCodeLinkModal: React.FC<IQRCodeLinkModalProps> = ({
  closeModal,
  surveyName,
}) => {
  return (
    <div className={cx('QRCodeLinkModal')}>
      <div className={cx('QRCodeLinkModal__row')}>
        <Text weight="semibold" size="m">
          {surveyName}
        </Text>
        <Button
          onClick={closeModal}
          className={cx('QRCodeLinkModal__button')}
          size="s"
          view="clear"
          iconRight={IconClose}
          onlyIcon
        />
      </div>
      <QRCodeLink />
    </div>
  );
};

export default QRCodeLinkModal;
